window.InputSelectActions = Reflux.createActions([
  'select',
  'selectSearchValue'
]);

module.exports = window.InputSelectActions;